import Link from '@/components/atoms/link';
import Button from '@/components/atoms/button';
import { Money } from '@shared/types/product';
import { desktop } from '@/constants/screensizes';
import useMediaQuery from '@/hooks/useMediaQuery';
import useFormat from '@/hooks/useFormat';
import { Currency } from '@/types/currency';
import { ChevronRightIcon } from '@heroicons/react/24/solid';

const ReviewHeader = ({ sum, handleReview }: { sum?: Money, handleReview: any }) => {
    const [isDesktop] = useMediaQuery(desktop);
    const headerFontSize = isDesktop ? 'text-32' : 'text-22';
    const linkFontSize = isDesktop ? 'text-17' : 'text-15';
    return <>
        <div className='lg:flex lg:w-full'>
            <div className='reviewheaders flex justify-between lg:w-full'>
                <div className='flex justify-between w-full'>
                    <div className='lg:ml-16'>
                        <h2 className={`font-semibold ${headerFontSize}  !mt-[12px] lg:!mt-[0px] mb-[4px] md:mb-[12px]`}>{isDesktop ? "Review Order" : "Checkout"}</h2>
                        <div className='flex gap-2 items-center md:mb-6 lg:mb-0'>
                            <Link className={linkFontSize} link={"/"} chevron={true}>Home</Link>
                            <div className='w-[17px] h-[17px]' >
                                <ChevronRightIcon width={17} fill='#000000' />
                            </div>
                            {isDesktop && <Link className={linkFontSize} link={"/cart"} chevron={true}>Cart</Link>}
                            {isDesktop && <div className='w-[17px] h-[17px]' >
                                <ChevronRightIcon width={17} fill='#000000' />
                            </div>}
                            <Link className={`${{ linkFontSize }} ${isDesktop ? '' : 'font-medium'}`} link={isDesktop ? "/checkout" : "/checkout/review"} chevron={isDesktop}>Checkout</Link>
                            {isDesktop && <div className='w-[16px] h-[16px]' >
                                <ChevronRightIcon width={17} fill='#000000' />
                            </div>}
                            {isDesktop && <Link className={`${linkFontSize} font-semibold`} link={"/checkout/review"} >Review</Link>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>

};

export default ReviewHeader;
